/** Anmeldung: als ganze Seite beim Start, als Fenster über der App, wenn die Sitzung abgelaufen ist. */
import { useEffect, useRef, useState } from "react";
import { useStore } from "../state/store";
import { login } from "../state/layouts";
import { ApiError } from "../api/client";

export function LoginScreen({ overlay = false }: { overlay?: boolean }) {
  const me = useStore((s) => s.me);
  const [username, setUsername] = useState(me?.username || "");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const pw = useRef<HTMLInputElement>(null), un = useRef<HTMLInputElement>(null);
  useEffect(() => { (me ? pw : un).current?.focus(); }, [me]);
  useEffect(() => { if (!overlay) document.title = "Anmelden · Hausplaner"; }, [overlay]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); if (busy) return;
    setBusy(true); setError(null);
    try { await login(username.trim(), password, remember); }
    catch (err) {
      setError(err instanceof ApiError && err.status !== 0 ? err.message : "Server nicht erreichbar – bitte später erneut versuchen");
      setPassword(""); pw.current?.focus();
    } finally { setBusy(false); }
  };

  return (
    <div className={overlay ? "login-overlay" : "login-page"} role={overlay ? "dialog" : undefined} aria-modal={overlay || undefined} aria-labelledby="login-title">
      <form className="login-card" onSubmit={submit} id="loginform">
        <div className="tblock login-tb">
          <div className="k">Objekt</div><div className="name">Rosenstraße 30</div>
          <div className="k">Programm</div><div>Hausplaner</div>
        </div>
        <h1 id="login-title">{overlay ? "Sitzung abgelaufen" : "Anmelden"}</h1>
        {overlay && <p className="note">Deine Änderungen sind in diesem Browser gesichert und werden nach der Anmeldung gespeichert.</p>}
        <label className="field" htmlFor="lg-user"><span>Benutzername</span>
          <input id="lg-user" ref={un} name="username" autoComplete="username" autoCapitalize="none" spellCheck={false} required value={username} onChange={(e) => setUsername(e.target.value)} />
        </label>
        <label className="field" htmlFor="lg-pass"><span>Passwort</span>
          <input id="lg-pass" ref={pw} name="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <label className="toggle" htmlFor="lg-remember"><span>Angemeldet bleiben (30 Tage)</span>
          <input id="lg-remember" type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
        </label>
        {error && <p className="warn" role="alert" id="lg-error">{error}</p>}
        <button className="btn primary" type="submit" id="lg-submit" disabled={busy}>{busy ? "Anmelden …" : "Anmelden"}</button>
        {!overlay && <p className="note">Zugang bekommst du von Patrick.</p>}
      </form>
    </div>
  );
}
